import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogHelper, ExceptionHelper } from '../../../../helper';
import { SiteEquipmentLayoutPlanService } from './site-equipment-layout-plan.service';

@Component({
  selector: 'app-site-equipment-layout-plan',
  templateUrl: './site-equipment-layout-plan.component.html',
  styleUrls: ['./site-equipment-layout-plan.component.css'], 
})
export class SiteEquipmentLayoutPlanComponent implements OnInit {
  @ViewChild('successModal') successModal: any;
  planForm: FormGroup;
  data = [];
  projects: any[] = [];
  itemId = null;
  siteId = null;
  projectId = null;
  jobNumber = '';
  constructor(
    private dialog: DialogHelper,

    private exception: ExceptionHelper,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private planService: SiteEquipmentLayoutPlanService

  ) {
    this.planForm = this.fb.group({
      projectId: [null],
      itemLabel: ['', [Validators.required]],
      itemFileName: ['', []],
      itemFileId: [null],
      itemFileStatus: [[], [Validators.required]],
      itemDescription: [null],
      itemRemarks: [null],
    });

   }

   public onClose(e: any): void {
    if (this.planForm.value.itemFileStatus.length === 0) {
      this.planForm.controls['itemFileStatus'].setErrors({ 'required': true });
    }
  }
  
  ngOnInit() {
    this.data = [{name: 'Pending', shortName: 'Pending', id: 0}, {name: 'Uploaded', shortName: 'Uploaded', id: 1},{name: 'N.A.', shortName: 'N.A.', id: 2},]

   this.route.params.subscribe(res => {
    this.siteId = res.siteId;
     if(res.itemId) {
       
      this.planService.getSiteEquipmentLayoutPlan(res.siteId, res.itemId).subscribe(data => {
        this.itemId = data.itemId;
        this.jobNumber = data.jobNumber;        
        this.projectId = data.projectId;
        this.planForm.patchValue({
         itemLabel: data.itemLabel,
         itemFileName: data.itemFileName,
         itemFileId: data.itemFileId,
         itemFileStatus: [this.data.find(x => x.id === data.itemFileStatus)],
         itemDescription: data.itemDescription,
         itemRemarks: data.itemRemarks,
        });
      });
     }
     else {
      this.planForm.get('projectId').setValidators(Validators.required);
      this.planForm.updateValueAndValidity();
     }
     
     this.planService.getProjects(res.siteId).subscribe(res => {
       this.projects = res.projects.map(x => {
         return {
           ...x,
          name: x.jobNumber,
          shortName: x.jobNumber,
          id: x.projectId,
         }
       });
       if(this.itemId) {
         this.planForm.patchValue({
           projectId:[this.projects.find(x => x.id === this.projectId)],
          });       
        }
     })
   });
   
  }
  closeSuccessModel() {
    this.router.navigate(['/home/site/detail', this.siteId]);
  }
  
  checkFile() {
    this.planForm.get('itemFileName').markAsTouched();
  }
  submitForm(form) {
    console.log(this.planForm.value);
    if(this.itemId) {
      this.planService.edit(this.siteId, this.itemId,{
        ...this.planForm.value,
        itemFileStatus: this.planForm.value.itemFileStatus[0].id,
      }).subscribe(res => {
this.dialog.showModal('showSucModalBtn');
      }, err => {
         this.exception.showError(err, 'showDanModalBtn');
      });
    } else {
      this.planService.create(this.siteId, {
        ...this.planForm.value,
        itemFileStatus: this.planForm.value.itemFileStatus[0].id,
        projectId: this.planForm.value.projectId[0].id,

      }).subscribe(res => {
this.dialog.showModal('showSucModalBtn');
      }, err => {
         this.exception.showError(err, 'showDanModalBtn');
      });
    }
  }

 
  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      console.log(event.target.files);      
      this.planService.uploadFile(event.target.files[0]).subscribe(res => {
        console.log(res);
        this.planForm.patchValue({
          itemFileName: res.files[0].fileName,
          itemFileId: res.files[0].fileId
        })
      })
    } else {

    }
  }
  removeFile() {
    this.planForm.patchValue({
      itemFileName: null,
      itemFileId: null,
    })
  }
  
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-equipment-layout-plan/site-equipment-layout-plan.component.ts